export default __webpack_public_path__ + "static/media/placeholder_business04-jp-web.f9b0b912.png";